@if (isShopManagementList) {
  <div class="pure-g m-t-16" style="align-items: center; display: flex; justify-content: flex-end">
    <div class="pure-u-md-6-24 pure-u-lg-5-24 pure-u-xl-4-24 right">
      @if (canAddNewShop) {
        <mc-button
          label="Add New"
          (click)="onAddNewShopClicked()"
          (keydown.enter)="onAddNewShopClicked()"
          variant="filled"
          appearance="primary"
          fit="small">
        </mc-button>
      }
    </div>
  </div>
}

<div class="m-t-8 quick-filter-box">
  <div class="applied-filter-holder">
    @for (taggedFilter of taggedFilters; track taggedFilter.key) {
      <!-- Filter Label -->
      <div class="m-r-4" style="white-space: nowrap">
        {{ taggedFilter.key }}
      </div>

      <!-- ARRAY VALUES (Shop Code, Type, Location, Status) -->
      @if (isArrayType(taggedFilter.value)) {
        <!-- SHOP CODE -->
        @if (taggedFilter.key == 'Shop Code') {
          <app-tag-with-overflow [data]="getTaggedShopCodes()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectShopCode()">
          </app-tag-with-overflow>
        }

        <!-- TYPE -->
        @if (taggedFilter.key == 'Type') {
          <app-tag-with-overflow [data]="getTaggedTypes()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectType()">
          </app-tag-with-overflow>
        }

        <!-- SHOP LOCATION -->
        @if (taggedFilter.key == 'Shop Location') {
          <app-tag-with-overflow [data]="getTaggedLocations()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectLocation()">
          </app-tag-with-overflow>
        }

        <!-- STATUS -->
        @if (taggedFilter.key == 'Status') {
          @for (status of getTaggedStatuses(); track status) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectStatus(status)"
              (keydown.enter)="unselectStatus(status)">
              {{ status ? 'Active' : 'Inactive' }}
            </mc-tag>
          }
        }
      } @else {
        <!-- NON-ARRAY FILTERS -->
        <mc-tag
          class="m-r-4 extra-height"
          appearance="neutral-inverse"
          fit="small"
          withaction
          (click)="unselectSpecificFilter(taggedFilter)"
          (keydown.enter)="unselectSpecificFilter(taggedFilter)">
          {{ getTaggedFilterValue(taggedFilter) }}
        </mc-tag>
      }
    }

    <!-- CLEAR ALL -->
    @if (taggedFilters.length > 0) {
      <a>
        <mc-button
          class="clear-btn"
          variant="plain"
          appearance="primary"
          fit="small"
          padding="default"
          (click)="clearAllSelectedFilters()"
          (keydown.enter)="clearAllSelectedFilters()">
          Clear All
        </mc-button>
      </a>
    }
  </div>

  <!-- RIGHT SIDE FILTER BUTTON -->
  <div class="utility-buttons">
    <div style="display: flex; align-items: right; gap: 1px">
      <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
        <mc-button
          class="utility-button-no-round"
          slot="trigger"
          icon="sliders-horizontal"
          variant="filled"
          appearance="neutral"
          hiddenlabel
          padding="default"
          fit="medium"
          (click)="showAdvanceFiltersModal()"
          (keydown.enter)="showAdvanceFiltersModal()">
        </mc-button>
        <span>Filters</span>
      </mc-tooltip>
      @if (authPolicies.canViewShopManagement) {
        <mc-button
          class="utility-button download"
          variant="filled"
          appearance="neutral"
          fit="medium"
          [loading]="isDownload"
          icon="tray-arrow-down"
          hiddenlabel
          padding="default"
          (click)="onDownload()"
          (keydown.enter)="onDownload()">
        </mc-button>
      }
    </div>
  </div>
</div>
<mc-modal [open]="showAdvanceFilters" (closed)="closeAdvanceFiltersModal()" heading="Filters" fit="small" dimension="large">
  <app-shop-management-advanced-filter
    [bindMultiSelects]="showAdvanceFilters"
    [shopManagementFilterForm]="filterFormGroup.controls.shopManagementFilterForm">
  </app-shop-management-advanced-filter>
</mc-modal>
